import ListEmptyContainerView from "./ListEmptyView";

/**
 * Container component for displaying empty state when no similar players are found.
 */
const ListEmptyContainer = () => {
  return <ListEmptyContainerView />;
};

export default ListEmptyContainer;
